export enum ProductSearchType {
  PART = 'part',
  SERIAL = 'serial',
}

export enum OfferTypes {
  REPAIR = 'Repair',
  CALIBRATION = 'calibrate',
  RETURN = 'Return',
}

export enum ServiceOfferingCategories {
  REPAIR = 'SRV1',
  CALIBRATION = 'SRV2',
}
